<!-- prettier-ignore -->
<label>
  <!-- tell prettier to not insert whitespaces -->
  <!-- display: inline -->
  <div class="form-field__label form-field__summary-label">
  @if (field?.label; as label) { {{label|translateInline }}}
  </div>
  <!-- only visible when printing -->
  <span class="form-field__summary-label-value-separator">: </span>
  <div
    class="form-field__summary form-field__summary-text"
    [innerHTML]="htmlContent$ | async"
  ></div>
</label>
